'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildCommonMessage = undefined;

var _immutable = require('immutable');

var _compose = require('transmute/compose');

var _compose2 = _interopRequireDefault(_compose);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _timestamps = require('../../lib/timestamps');

var _keyPaths = require('../constants/keyPaths');

var _generateUuid = require('../generateUuid');

var _CommonMessage = require('../records/CommonMessage');

var _CommonMessage2 = _interopRequireDefault(_CommonMessage);

var _Status = require('../records/Status');

var _Status2 = _interopRequireDefault(_Status);

var _buildAttachments = require('./buildAttachments');

var _commonMessageFormatGetters = require('./commonMessageFormatGetters');

var _commonMessageFormatSetters = require('./commonMessageFormatSetters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildCommonMessage = exports.buildCommonMessage = function buildCommonMessage() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var status = (0, _Status2.default)((0, _getIn2.default)(_keyPaths.STATUS, props));

  var attachments = (0, _buildAttachments.buildAttachments)(props.attachments);

  var id = (0, _commonMessageFormatGetters.getId)(props) || (0, _generateUuid.generateUuid)();

  var timestamp = (0, _commonMessageFormatGetters.getTimestamp)(props) || (0, _timestamps.generateUniqueClientTimestamp)('buildCommonMessage-timestamp');

  return (0, _compose2.default)((0, _commonMessageFormatSetters.setId)(id), (0, _commonMessageFormatSetters.setStatus)(status), (0, _commonMessageFormatSetters.setAttachments)(attachments), (0, _commonMessageFormatSetters.setTimestamp)(timestamp))((0, _CommonMessage2.default)((0, _immutable.fromJS)(props)));
};